import styled from 'styled-components'
import { tabletSize } from '../../../catalog/screen-sizes'

export const BannerTitle = styled.div`
  white-space: nowrap;
  margin-top: 40px;

  @media (max-width: ${tabletSize}) {
    margin-top: 30px;
  }
`
